import '../../src/App.css'
import React, { useState, useEffect, useRef } from 'react';
import { useSelector, connect } from 'react-redux';
import moment from "moment";
import { Button, Tooltip } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Select,
} from "@material-ui/core";

import socket from '../socket';
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import HttpService from '../services/httpService';
import decor_new_logo from '../assets/img/org/decor_new_logo.png'
import FileUploadMenu from './FileUploadMenu'
import FilePreview from './FilePreview';


const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 300,
    maxWidth: 500
  },
  tableHeader:{
    position: 'sticky',
    top: 0,
    zIndex: 1
  },
  textField: {
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
    width: 300,
  },
  paper: {
    padding: "2rem 2rem 2rem 2rem",
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  radioButton: {
    // padding:20,
    marginLeft: "20px",
  },
  heading: { margin: 'auto', textAlign: "center", color: "white", backgroundColor: "#2C2E3E", padding: 10, borderRadius: 50, width: "50%", fontSize: 20, marginTop: -20},
  editButton: { backgroundColor: 'white', color: '#3d444f', padding: '1', marginRight: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#3d444f", color: 'white' } },
  approveButton: { backgroundColor: 'white', color: '#157525', padding: '1', marginRight: '0.5em', marginLeft: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#157525", color: 'white' } },
  rejectButton: { backgroundColor: 'white', color: '#9c261e', padding: '1', marginRight: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#9c261e", color: 'white' } },
  yesButton: { backgroundColor: 'white', color: '#14419c', padding: '1', marginRight: '0.5em', marginLeft: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#14419c", color: 'white' } },
  noButton: { backgroundColor: 'white', color: '#151921', padding: '1', marginRight: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#151921", color: 'white' } },
  updateButton: { backgroundColor: 'white', color: '#157525', padding: '1', margin: 'auto', borderRadius: '20px', "&:hover": { backgroundColor: "#157525", color: 'white' } },
  financeActionRemarks: { margin: 'auto', width: '100%' },
  downloadButton: { backgroundColor: 'white', color: '#14419c', padding: '1', marginRight: '0.5em',  marginBottom: '0.5em', marginTop: '0.5em',  marginLeft: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#14419c", color: 'white' } },
  searchInput: {
    borderRadius: '50px',
    borderColor: '#2196F3'
  }
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ccc",
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 10,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    '&:hover': {
    backgroundColor: '#f47e46'
  }
  },
}))(TableRow);

const GroupChat = (props) => {
  const classes = useStyles();
  const messagesEndRef = useRef(null);
  const [cursorPosition, setCursorPosition] = useState(null);
  const { userDetails } = useSelector((state) => state.user);
  const { customerDetails } = useSelector((state) => state.customer);
  const [groups, setGroups] = useState([]);
  const [taggedUsers, setTaggedUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const inputRef = useRef(null);
  const [selectedGroup, setSelectedGroup] = useState({
    groupName: "",
    latestMessages: [],
    leadId: "",
    participants: [],
    projectId: "",
    _id: ""
  });
  const [messages, setMessages] = useState({});
  const [userUnderAction, setUserUnderAction] = useState({});
  const [selectedGroupDetails, setSelectedGroupDetails] = useState({participants: []});
  const [newMessage, setNewMessage] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showChatInterface, setShowChatInterface] = useState(false);
  const [showUserActionOptions, setShowUserActionOptions] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [showGroupDetails, setShowGroupDetails] = useState(false);
  const [showUserSelection, setShowUserSelection] = useState(false);
  const [usersLoaded, setUsersLoaded] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [selectedGroupUsers, setSelectedGroupUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [typingUser, setTypingUser] = useState(null);
  const [attachment, setAttachment] = useState([]);
  const [typeOfMessage, setTypeOfMessage] = useState('text');
  const [hoveredGroup, setHoveredGroup] = React.useState(null);

  // Fetch groups from the backend
  const fetchGroups = async () => {
    const userId = userDetails._id || props.customerDetails?._id
    const response = await HttpService.chatGroups(userId);
    setGroups(response.data.chatGroups);
    setMessages(response.data.chatMessages);
  };

  // Handle sending a message
  const handleSendMessage = async () => {
    if ((!newMessage.trim() && !attachment) || !selectedGroup) return;
    console.log('userDetails: ', userDetails)
    console.log('customerDetails: ', customerDetails)
    const messageData = {
      groupId: selectedGroup._id,
      sender: Object.keys(userDetails).length ? userDetails : customerDetails,
      content: newMessage,
      messageType: typeOfMessage,
      attachments: attachment,
      taggedUsers: taggedUsers,
      timestamp: new Date()
    };  
    console.log('messageData:', messageData);
    socket.emit('sendMessage', messageData);
    setNewMessage('');
    setTaggedUsers([])
    setAttachment([]);
    setTypeOfMessage(null);
  };

  const handleFileSelect = async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('groupId', selectedGroup._id);
      const response = await HttpService.uploadFile(formData);
      setTypeOfMessage(file.type)
      let finalAttachments = attachment
      finalAttachments.push(response.data)
      setAttachment(finalAttachments)
      setNewMessage(newMessage + response.data)
      if (inputRef.current) {
        inputRef.current.focus();
      }

    } catch (error) {
      console.error('Error uploading file:', error);
      props.setSnackInfo('Error uploading file', 'error');
    }
  };

  const handleCancelAttachment = () => {
    setAttachment([]);
    setTypeOfMessage(null);
    setNewMessage('')
  };

  const fetchGroupMessages = async (groupId) => {
    try {
      const response = await HttpService.groupMessages(groupId)
      return response.data;
    } catch (error) {
      console.log('error: ', error.message)
      console.error('Error fetching messages:', error.message);
      return [];
    }
  };

  const loadMessages = async () => {
    if (selectedGroup) {
      const messages = await fetchGroupMessages(selectedGroup?._id);
      console.log('got messages: ', messages)
      setMessages((prev) => ({
        ...prev,
        [selectedGroup._id]: [...messages],
      }));
    }
  };

  const handleTyping = (e) => {
    setNewMessage(e.target.value);
    if (selectedGroup) {
      socket.emit('typing', {
        groupId: selectedGroup?._id,
        isTyping: e.target.value.length > 0,
        username: userDetails.name || customerDetails.name
      });
      setTimeout(() => {
        socket.emit('typing', { groupId: selectedGroup._id, isTyping: false, username: userDetails.name })
      }, 1000);

      const lastWord = e.target.value.split(/\s+/).pop();
      if (lastWord.startsWith('@')) {
        const query = lastWord.slice(1).toLowerCase();
        const suggestions = selectedGroupUsers.filter((user) => user.name.toLowerCase().includes(query));
        setFilteredUsers(suggestions);
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    }
  };

  const handleSelectUser = (user) => {
    const words = newMessage.split(/\s+/);
    words[words.length - 1] = `@${user.name} `;
    const updatedMessage = words.join(' ');
    setNewMessage(updatedMessage);
    setTaggedUsers((prev) => [...prev, user]);
    setShowSuggestions(false);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const handleGroupSelect = (group) => {
    if (selectedGroup) {
      socket.emit('leaveGroup', { groupId: selectedGroup._id });
    }
    socket.emit('joinGroup', { groupId: group._id });
    setSelectedGroup(group);
    setSelectedGroupUsers(group.groupUsers)
    setShowChatInterface(true)
    setShowSuggestions(false)
    setTaggedUsers([])
    setFilteredUsers([])
    setNewMessage('')
  };

  const renderMessageContent = (content) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return content.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline", color: "white" }}
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };

  const handleChatHeaderClick = async () => {
    setShowGroupDetails(!showGroupDetails)
  }

  const handleUserClick = async (input) => {
    if(userDetails.name == 'Admin') {
      setUserUnderAction(input)
      setShowUserActionOptions(true)
    }
  }

  const handleAddUserClick = async () => {
    setShowUserSelection(true)
    props.setLoading(true)
    try {
      const response = await HttpService.getAllUsersForGroupChat()
      setAllUsers(response.data)
      setUsersLoaded(true)
    } catch(err) {
      console.error(err.message)
    }
    props.setLoading(false)
  }
  
  const handleUserAction = async (input) => {
    props.setLoading(true)
    let data = {}
    data.groupId = selectedGroup._id
    data.userId = Object.keys(userUnderAction).length ? userUnderAction.userId : userDetails._id
    data.usersToAddInGroup = selectedUsers
    if(input == 'make_admin') {
      data.role = 'admin'
      try {
        const response = await HttpService.updateParticipantRole(data)
        props.setSnackInfo(`${response.data.message || 'Updated Successfully!'}`, 'success')
      } catch(err) {
        console.error(err.message)
        props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error")
      }
      
    } else {
      if(input == 'add_user') {
        data.action = 'add'
      }
      else if(input == 'remove_user') {
        data.action = 'remove'
        console.log('data for remove_user: ', data)
      }
      
      try {
        const response = await HttpService.addOrRemoveParticipant(data)
        props.setSnackInfo(`${response.data.message || 'Updated Successfully!'}`, 'success')
      } catch(err) {
        console.error(err.message)
        props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error")
      }
    }
    setShowUserActionOptions(false)
    setShowGroupDetails(false)
    setShowUserSelection(false)
    setUsersLoaded(false)
    setSelectedUsers([])
    props.setLoading(false)
  }



  useEffect(() => {  
    socket.on('typing', ({ groupId, isTyping, username }) => {
      if (groupId === selectedGroup?._id) {
        setIsTyping(isTyping);
        setTypingUser(isTyping ? username : null);
      }
    });
    socket.on('receiveMessage', (messageData) => {
      const { groupId, sender, content, timestamp } = messageData;
      setMessages((prev) => ({
        ...prev,
        [groupId]: [
          ...(prev[groupId] || []),
          { sender,
            content: content,
            timestamp: timestamp
          },
        ],
      }));
    });

    return () => {
      socket.off('typing');
      socket.off('receiveMessage');
    };
  }, [selectedGroup]);

  useEffect(() => {
    socket.connect();
    
    socket.on('connect', () => {
      console.log('Socket connected:', socket.id); //we need this to ensure user is connected
      fetchGroups();
      socket.emit('userConnected', userDetails)
    });

    socket.on('receiveMessage', (messageData) => {
      const { groupId, sender, content, timestamp } = messageData;
      setMessages((prev) => ({
        ...prev,
        [groupId]: [
          ...(prev[groupId] || []),
          { sender,
            content: content,
            timestamp: timestamp
          },
        ],
      }));
    });

    socket.on('disconnect', () => {
      // console.log('Socket disconnected');
    });
    
    return () => {
      socket.emit('userDisconnected', userDetails)
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, messages[selectedGroup._id]])


  return (
    <div style={{ display: 'flex', width: "100%", height: "100vh", background: '#1e1e1e', fontFamily: 'Arial, sans-serif', color: '#e4e6eb' }}>
      
      {/* Left Sidebar */}
      {/* <div style={{ width: '5%', background: '#2a2f32', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '10px' }}> */}
        {/* <div style={{ marginBottom: '20px', cursor: 'pointer' }}>
          <i className="fas fa-cog" style={{ color: '#fff' }}>S1</i>
        </div>
        <div style={{ marginBottom: '20px', cursor: 'pointer' }}>
          <i className="fas fa-comment-alt" style={{ color: '#fff' }}>S2</i>
        </div>
        <div style={{ marginBottom: '20px', cursor: 'pointer' }}>
          <i className="fas fa-comment-alt" style={{ color: '#fff' }}>S3</i>
        </div>
        <div style={{ marginBottom: '220px', cursor: 'pointer' }}>
          <i className="fas fa-comment-alt" style={{ color: '#fff' }}>S4</i>
        </div>
        <div style={{ marginBottom: '20px', cursor: 'pointer' }}>
          <i className="fas fa-comment-alt" style={{ color: '#fff' }}>S5</i>
        </div>
        <div style={{ cursor: 'pointer' }}>
          <i className="fas fa-comment-alt" style={{ color: '#fff' }}>S6</i>
        </div> */}
      {/* </div> */}
      
      {/* Groups List */}
      {/* <div style={{ width: '35%', background: '#121212', overflowY: 'auto', height: '100vh' }}> */}
      <div style={{ 
        width: '35%', 
        background: '#121212', 
        display: 'flex',
        flexDirection: 'column',
        height: '60vh',
        overflow: 'hidden'
      }}>
        {/* Groups Header - Fixed */}
        <div style={{
          padding: '15px',
          borderBottom: '1px solid #333',
          background: '#121212',
          display: 'flex',
          alignItems: 'center'
        }}>
          {/* Groups <span style={{marginLeft: "60%", fontSize: "30px", cursor: 'pointer'}} onClick={handleCreateGroup}>+</span> */}
          Groups
        </div>
        {/* Groups List - Scrollable */}
        <div style={{ 
          flex: 1,
          overflowY: 'scroll',
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {  /* Chrome, Safari and Opera */
            display: 'none'
          }
        }}>
          
          {/* <div style={{
              flex: 1,
              overflowY: 'scroll',
              padding: '10px',
              background: '#1e1e1e',
              msOverflowStyle: 'none',
              scrollbarWidth: 'none',
              '&::-webkit-scrollbar': {
                display: 'none'
              }
            }}></div> */}
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {/* <li
            style={{
              padding: '15px',
              // cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              borderBottom: '1px solid #333',
              background: '#121212',
            }}>
              Groups <span style={{marginLeft: "60%", fontSize: "30px", cursor: 'pointer',}} onClick={handleCreateGroup}>+</span>
            </li> */}
            {groups.map((group) => (
              <li
                key={group._id}
                onClick={() => handleGroupSelect(group)}
                onMouseEnter={() => setHoveredGroup(group._id)}
                onMouseLeave={() => setHoveredGroup(null)}
                style={{
                  padding: '15px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  borderBottom: '1px solid #333',
                  // background: selectedGroup?._id === group._id ? '#3a3b3c' : '#121212',
                  background: hoveredGroup === group._id ? '#f47e46' : selectedGroup?._id === group._id ? '#3a3b3c' : '#121212',
                  transition: 'background 0.3s ease',
                }}
              >
                
                {/* Group Icon */}
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    background: '#333',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '10px',
                  }}
                >
                  {/* {group.groupName.charAt(0).toUpperCase()} */}
                  <img className="decor_new_logo" src={decor_new_logo} alt="decorpot logo" />

                </div>
              
                {/* Group Details */}
                <div style={{ flex: 1 }}>
                  <h4 style={{ margin: 0, fontSize: '14px', color: '#e4e6eb' }}>{group.groupName}</h4>
                  <p style={{ margin: 0, fontSize: '12px', color: '#bbb' }}>{group.lastMessage}</p>
                </div>
                
                {/* Unread Count */}
                {group.unread > 0 && (
                  <div
                    style={{
                      background: '#25d366',
                      borderRadius: '50%',
                      width: '20px',
                      height: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                      fontSize: '12px',
                    }}
                  >
                    {group.unread}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Chat Area */}
      {/* <div style={{ width: "60%", display: 'flex', flexDirection: 'column', height: '60vh' }}> */}
      {/* Chat Area */}
      <div style={{ 
        width: "60%", 
        display: 'flex', 
        flexDirection: 'column', 
        height: '60vh',
        overflow: 'hidden'
      }}>
        {showChatInterface ? (
          <>
          
          {/* Chat Header */}
          <div
            style={{
              padding: '10px',
              background: '#2a2f32',
              borderBottom: '1px solid #333',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              // flexShrink: 0,
            }}
          >
            <h3 style={{ margin: 0, fontSize: '16px', color: '#e4e6eb', cursor: 'pointer' }} onClick={handleChatHeaderClick}>{selectedGroup.groupName}</h3>
            <button
              onClick={() => setShowChatInterface(false)}
              // onClick={() => props.onClose()}
              style={{
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                color: '#e4e6eb'
              }}
            >
              Back
            </button>
          </div>
          
            {/* Messages */}
            <div style={{
              flex: 1,
              overflowY: 'scroll',
              padding: '10px',
              background: '#1e1e1e',
              msOverflowStyle: 'none',
              scrollbarWidth: 'none',
              '&::-webkit-scrollbar': {
                display: 'none'
              }
            }}>
              {(messages[selectedGroup._id] || []).map((msg, index) => {

                const timestamp = new Date(msg.timestamp);
                const now = new Date();
                const diffInDays = Math.floor((now - timestamp) / (1000 * 3600 * 24));

                let formattedDate;

                if (diffInDays === 0) {
                  formattedDate = 'Today';
                } else if (diffInDays === 1) {
                  formattedDate = 'Yesterday';
                } else {
                  formattedDate = timestamp.toLocaleString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric',
                  });
                }

                const formattedTime = timestamp.toLocaleTimeString([], { 
                  hour: '2-digit', 
                  minute: '2-digit', 
                  second: '2-digit', 
                  hour12: true 
                });
                return (
                  <div
                  key={index}
                  style={{
                    marginBottom: '10px',
                    textAlign: msg.sender.name === (Object.keys(userDetails).length ? userDetails.name : customerDetails.name) ? 'right' : 'left',
                  }}
                  >
                
                    {/* Sender's Name and Message Content */}
                    <div
                      style={{
                        display: 'inline-block',
                        padding: '8px 12px',
                        borderRadius: '10px',
                        background: msg.sender.name === (Object.keys(userDetails).length ? userDetails.name : customerDetails.name) ? '#0084ff' : '#3a3b3c',
                        color: '#fff',
                        textAlign: 'left',
                        minWidth: '40%',
                        maxWidth: '75%', // Prevents messages from stretching too wide
                        wordBreak: 'break-word', // Ensures long words wrap
                        whiteSpace: 'pre-wrap', // Preserves spacing while wrapping text
                      }}
                    >
                      {msg.sender.name !==  (Object.keys(userDetails).length ? userDetails.name : customerDetails.name) && (
                        <span
                          style={{
                            fontWeight: 'bold',
                            display: 'block',
                            marginBottom: '4px',
                          }}
                        >
                          {msg.sender.name}
                        </span>
                      )}
                      <span>
                        {/* {isValidUrl(msg.content) ? (
                          <a
                            href={msg.content}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{textDecoration: 'underline', color: 'white' }}
                          >
                            {msg.content}
                          </a>
                        ) : (
                          msg.content
                        )} */}
                        {renderMessageContent(msg.content)}
                      </span>
                      <span
                        style={{
                          fontSize: '.5em',
                          display: 'block',
                          textAlign: 'right'
                        }}
                      >
                        {/* {new Date(msg.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })} */}
                        {`${formattedDate}, ${formattedTime}`}
                      </span>
                    </div>
                  </div>
                )
              })}
            <div ref={messagesEndRef} />
          </div>

          {/* Typing Indicator */}
          {isTyping && (
            <div className="typing-indicator">
              {typingUser + ' '}
              <span className="typing-dot"></span>
              <span className="typing-dot"></span>
              <span className="typing-dot"></span>
            </div>
          )}

          {/* Message Input */}
          <div style={{ 
            padding: '10px', 
            background: '#2a2f32', 
            borderTop: '1px solid #333'
          }}>
            {/* File Preview */}
            {attachment && (
              <FilePreview
                attachment={attachment}
                typeOfMessage={typeOfMessage}
                onCancel={handleCancelAttachment}
              />
            )}

            {/* Input Area */}
            <span style={{ 
              display: 'flex',
              alignItems: 'center',
              position: 'relative'
            }}>
            <FileUploadMenu onFileSelect={handleFileSelect} />
            <input
              ref={inputRef}
              type="text"
              placeholder="Type a message"
              value={newMessage}
              onChange={handleTyping}
              style={{
                flex: 1,
                padding: '10px',
                borderRadius: '20px',
                border: 'none',
                background: '#404040',
                color: '#e4e6eb',
              }}
            />
            {showSuggestions && (
              <ul
                style={{
                  position: 'absolute',
                  top: '-500%',
                  bottom: '120%',
                  left: 0,
                  background: '#fff',
                  borderRadius: '5px',
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  width: '50%',
                  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                  maxHeight: '200px',
                  overflowY: 'auto',
                  fontSize: '0.9em',
                  scrollbarWidth: 'none',
                }}
              >
                {filteredUsers.map((user) => (
                  <li
                    key={user._id}
                    onClick={() => handleSelectUser(user)}
                    style={{
                      padding: '10px',
                      cursor: 'pointer',
                      background: '#2c2e3e',
                      transition: 'background-color 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.background = '#f47e46'}
                    onMouseLeave={(e) => e.target.style.background = '#2c2e3e'} 
                  >
                    {user.name}
                  </li>
                ))}
              </ul>
            )}
            <button
              disabled={!Boolean(newMessage)}
              onClick={handleSendMessage}
              style={{
                marginLeft: '10px',
                padding: '10px 15px',
                border: 'none',
                borderRadius: '20px',
                background: '#0084ff',
                color: '#fff',
                cursor: 'pointer',
              }}
            >
              Send
            </button>
            </span>
          </div>
        </>
      ) : (
        <div 
          style={{ 
            flex: 1,
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center', 
            justifyContent: 'center', 
            color: '#888' 
          }}
        >
          <i className="fas fa-comments" style={{ fontSize: '48px', marginBottom: '10px' }}></i>
          <p>Select a group to start chatting</p>
        </div>
      )}
    </div>

    {/* show group details */}
    <Dialog open={showGroupDetails} onClose={() => {setShowGroupDetails(!showGroupDetails); setSelectedGroupDetails({...selectedGroupDetails, participants: []})}} aria-labelledby="form-dialog-title" style={{padding:"10rem 10rem 10rem 10rem"}}>
          <div>
            <Button variant="contained" color="primary" style={{ alignSelf: "center", marginTop: 10, marginLeft: 10, fontSize: 10 }} onClick={() => {setShowGroupDetails(!showGroupDetails); setSelectedGroupDetails({...selectedGroupDetails, participants: []})}} >
              Back
            </Button>
          </div>
      <DialogTitle id="form-dialog-title" style={{ textAlign: "center" }}>
          {selectedGroup?.groupName}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Table className={classes.table} size="small" aria-label="customized table">
            {/* <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">
              {
                userDetails.roles && userDetails.roles.find(role => 
                  role.name === ROLENAME.Admin ||
                  role.name === ROLENAME.SalesManager ||
                  role.name === ROLENAME.OperationDesignManager ||
                  role.name === ROLENAME.DesignManager ||
                  role.name === ROLENAME.AssistantDesignManager
                ) &&
                  <Button variant="contained" color="primary" style={{ alignSelf: "center", fontSize: 10 }} onClick={() => handleAddUserClick()} >
                    Add User
                  </Button>
              }
            </StyledTableCell> */}
            <StyledTableRow>
              <StyledTableCell style={{textAlign:"center", backgroundColor: '#f47e46', color: 'white' }} component="th" scope="row">Participants</StyledTableCell>                  
            </StyledTableRow>
            <TableBody>
              {selectedGroup?.participants.map((row, i) => {
                  return (
                      <StyledTableRow key={i + 1}>
                        {/* {
                          row.role == 'admin' ?
                          <StyledTableCell style={{textAlign:"center" }} component="td" scope="row" onClick={() => handleUserClick(row)}>{`${row.userDetails.name} (${row.role})`}</StyledTableCell> :
                          <StyledTableCell style={{textAlign:"center" }} component="td" scope="row" onClick={() => handleUserClick(row)}>{`${row.userDetails.name}`}</StyledTableCell>
                        } */}
                        <StyledTableCell style={{textAlign:"center" }} component="td" scope="row" onClick={() => handleUserClick(row)}>{`${row.userDetails.name}`}</StyledTableCell>
                      </StyledTableRow>
                  );
              })}
              {
              userDetails.name &&
                <StyledTableRow style={{textAlign: 'center'}}>
                  <Button variant="contained" color="secondary" style={{ alignSelf: "center", marginTop: 20, fontSize: 10 }} onClick={() => handleUserAction('remove_user')} >
                    Exit Group
                  </Button>
                </StyledTableRow>
              }
            </TableBody>
          </Table>
        </DialogContentText>
      </DialogContent>
    </Dialog>

    {/* show actions for a user in participants list */}
    <Dialog open={showUserActionOptions} onClose={() => {setShowUserActionOptions(false); setUserUnderAction({})}} aria-labelledby="form-dialog-title" style={{padding:"10rem 10rem 10rem 10rem"}}>
      <DialogTitle>
      <Button variant="contained" color="primary" style={{ alignSelf: "center", marginLeft: 20, fontSize: 10 }} onClick={() => {setShowUserActionOptions(false); setUserUnderAction({})}} >
        Back
      </Button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Table className={classes.table} size="small" aria-label="customized table">
            <TableBody>
              <StyledTableRow>
                <StyledTableCell style={{textAlign:"center", cursor: "pointer" }} component="td" scope="row" onClick={() => handleUserAction('remove_user')}>{`Remove ${userUnderAction.userDetails?.name}`}</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell style={{textAlign:"center", cursor: "pointer" }} component="td" scope="row" onClick={() => handleUserAction('make_admin')}>{`Make group Admin`}</StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </DialogContentText>
      </DialogContent>
    </Dialog>
    
    {/* show users to add in the group */}
    <Dialog open={showUserSelection} onClose={() => {setShowUserActionOptions(false)}} aria-labelledby="form-dialog-title"
    PaperProps={{
      style: {
        minWidth: "300px",
        minHeight: "200px",
        // padding: "10rem 10rem 10rem 10rem"
      }
    }}
    >
      <div>
        <Button variant="contained" color="primary" style={{ alignSelf: "center", marginTop: 10, marginLeft: 10, fontSize: 10 }} onClick={() => {setShowUserSelection(false); setUsersLoaded(false); setSelectedUsers([])}} >
          Back
        </Button>
      </div>

      {!usersLoaded && (
        <div className="typing-indicator">
        <DialogTitle>
          Fetching Users
        </DialogTitle>
        <span className="typing-dot"></span>
        <span className="typing-dot"></span>
        <span className="typing-dot"></span>
      </div>

      )}

      {usersLoaded &&
      <>
        <DialogTitle style={{textAlign: 'center'}}>
          {/* Select Users */}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Table className={classes.table} size="small" aria-label="customized table">
              <TableBody>
                <Autocomplete
                  multiple
                  options={allUsers}
                  value={selectedUsers}
                  onChange={(e, v) => setSelectedUsers(v)}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Select users"
                        variant="outlined"
                    />
                  )}
                />
              </TableBody>
            </Table>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={!selectedUsers.length} onClick={() => handleUserAction('add_user')} variant="outlined" color="primary">
            Add
          </Button>
        </DialogActions>
      </>
    }
    </Dialog>
    
  </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(GroupChat);
